<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 用户管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>部门管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
			<div class="handle-box">
				<el-input class="handle-input mr10"
					placeholder="输入关键字进行过滤"
					v-model="filterText">
				</el-input>&nbsp;
				<el-button type="primary" icon="el-icon-lx-add" class="handle-del mr10" @click="handleAdd" v-if="controll['add']">添加一级记录</el-button>
			</div>
			<el-table
				:data="dataSource.filter(data => !filterText || data.label.toLowerCase().includes(filterText.toLowerCase()))"
				style="width: 100%;margin-bottom: 20px;"
				row-key="id"
				border
				size="medium"
				default-expand-all
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column
				  prop="label"
				  label="部门名称">
				</el-table-column>
				<el-table-column
				  prop="remark"
				  label="说明">
				</el-table-column>
				<el-table-column label="操作" width="180" align="center">
					<template slot-scope="scope">
						<el-button
							type="text"
							icon="el-icon-lx-add"
							@click="append(scope.row)"
							v-if="controll['add']"
						>新增</el-button>
						<el-button
							type="text"
							icon="el-icon-delete"
							class="red"
							@click="remove(scope.row)"
							v-if="controll['delete']"
						>删除</el-button>
					</template>
				</el-table-column>
			</el-table>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="添加部门信息" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-form-item label="父节点" prop="parentId" v-if="form.parentId">
					<el-input v-model="form.parentName" readonly=true></el-input>
                    <el-input v-model="form.parentId" style="display:none"></el-input>
                </el-form-item>
                <el-form-item label="部门名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
				<el-form-item label="部门类型" prop="departmentType" v-if="form.parentId==undefined">
                    <el-select v-model="form.departmentType" placeholder="请选择部门类型" style="width:150px">
						<el-option key="" label="请选择" value=""></el-option>
						<el-option v-for="item in postionKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
                </el-form-item>
				<el-form-item label="说明" prop="remark">
                    <el-input type=textarea :rows=3 v-model="form.remark"></el-input>
                </el-form-item>
            </el-form>  
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { getDepartmentTreeData, saveDepartment, deleteDepartment, getDepartment, getPostionKV} from '../../../api/index';
export default {
    name: 'department',
    data() {
        return {
            dataSource: [],
            editVisible: false,
            form: {},
			rules: {
                name: [{ required: true, message: '请输入部门名称', trigger: 'blur' }]
            },
			filterText:"",
			currentData:{},
			postionKV:[],
			controll:[]
        };
    },
    created() {
		this.controll = getControll("department");
        this.getData();
		this.getPostion();
    },
    methods: {
        // 获取树形结构数据
        getData() {
            getDepartmentTreeData().then(res => { 
				if (res.code == 0 ) {
					this.dataSource = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		//获取职务类型
		getPostion() {
			this.postionKV = [];
			getPostionKV().then(res => { 
				if (res.code == 0 ) {
					this.postionKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
		},
        // 删除操作
        remove(data) {
            // 二次确认删除
			let confirmStr = '确定要删除 ' + data.label + ' 吗？';
			if (data.children.length > 0) {
				confirmStr = data.label + '有子节点，删除会同步清除，确定要删除 ' + data.label + ' 吗？';
			}
            this.$confirm(confirmStr, '提示', {
                type: 'warning'
            })
                .then(() => {
					let ids = [];
					this.getIds(ids, data);
					deleteDepartment(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },		
		getIds(ids, data) {
			ids.push(data.id);
			if (data.children) {
				for(let i = 0; i < data.children.length; i++) {
					this.getIds(ids, data.children[i]);
				}
			}
		},		
		//添加操作
		handleAdd() {
			this.form = {};
			this.$set(this.form, "parentId", undefined);
			this.$set(this.form, "name", undefined);
			this.$set(this.form, "parentName", undefined);
			this.currentData = undefined;
			this.editVisible = true;
		},	
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveDepartment(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		append(data) {
			this.form = {};
			this.$set(this.form, "parentId", data.id);
			this.$set(this.form, "name", undefined);
			this.$set(this.form, "parentName", data.label);
			this.editVisible = true;
			this.currentData = data;
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>